var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransversePlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.038,
    height: 24.38,
    viewBox: "0 0 22.038 24.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_24_move3_px24",
    transform: "translate(0.214 0.23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M5469.3,1544.362a1.629,1.629,0,0,0-1.409-.81h-3.629l-6.876-10.02-.014-.019-.014-.02,0,0,0-.006a1.633,1.633,0,0,0-2.672,1.833l0,.006v0c.008.015.017.028.025.042l0,0,3.379,4.916L5454,1543.4h0a2.769,2.769,0,0,0-.806.986l-5.162,9.908a.119.119,0,0,1-.007.015c0,.005-.005.01-.008.015s0,.013-.007.019l0,.005a1.849,1.849,0,0,0,3.271,1.7l.01-.016,0,0,0-.007.013-.022,3.85-7.406,2.048,1.345-.671,4.893h0a1.851,1.851,0,0,0,2.537,1.955,1.8,1.8,0,0,0,1.111-1.448h0v0h0l.84-6.157h0a1.68,1.68,0,0,0-.739-1.624h0l-1.893-1.242,2.53-1.917,1.162,1.711h0l0,0a1.557,1.557,0,0,0,1.284.683h4.52a1.622,1.622,0,0,0,1.409-2.433Zm-18.989,11.092a.712.712,0,0,1-1.256-.656l4.146-7.956a2.771,2.771,0,0,0,.97,1.1h0l.033.022Zm17.579-9.8h-4.518a.415.415,0,0,1-.346-.188h0l-1.363-2.009h0a.773.773,0,0,0-.518-.348.807.807,0,0,0-.612.153h0l-3.215,2.436h0a.781.781,0,0,0-.31.657.791.791,0,0,0,.354.637h0l2.3,1.51h0a.534.534,0,0,1,.235.519h0l-.84,6.162v0a.668.668,0,0,1-.416.547.716.716,0,0,1-.978-.746v0l.719-5.249a.09.09,0,0,1,0-.011c0-.011,0-.023,0-.034s0-.017,0-.025a.282.282,0,0,0,0-.029c0-.01,0-.02,0-.029a.138.138,0,0,0,0-.024c0-.01,0-.021,0-.032s0-.014-.005-.021,0-.021-.008-.032,0-.015-.007-.022l-.01-.029-.011-.024-.012-.024c-.005-.009-.009-.018-.015-.027l-.012-.02-.018-.027-.013-.017-.022-.025a.133.133,0,0,0-.016-.017.205.205,0,0,0-.021-.021l-.021-.019-.02-.016-.027-.02-.01-.007-3.337-2.192h0a1.656,1.656,0,0,1-.1-2.689h0l4.262-3.251h0a.9.9,0,0,0,.2-1.225h0l-3.486-5.072a.5.5,0,0,1,.8-.552l6.959,10.14.01.014a.793.793,0,0,0,.648.331h3.807a.491.491,0,0,1,.424.242.484.484,0,0,1,0,.485.49.49,0,0,1-.424.242Z",
    transform: "translate(-5447.862 -1532.927)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M5578.779,1565.532a2.357,2.357,0,1,0-2.357-2.356A2.359,2.359,0,0,0,5578.779,1565.532Zm0-3.666a1.31,1.31,0,1,1-1.311,1.31A1.311,1.311,0,0,1,5578.779,1561.866Z",
    transform: "translate(-5561.917 -1556.784)",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M5595.46,1658.432a1.152,1.152,0,1,0,1.152,1.152A1.153,1.153,0,0,0,5595.46,1658.432Zm0,1.513a.361.361,0,1,1,.361-.361A.362.362,0,0,1,5595.46,1659.945Z",
    transform: "translate(-5576.241 -1643.603)",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransversePlane);
export default __webpack_public_path__ + "static/media/TransversePlane.b42f36b2dcaa22850ce2aa736ade947b.svg";
export { ForwardRef as ReactComponent };